import { Form } from '@mairistem/composants';
import { Panel } from '@mairistem/finances-utils';
import React from 'react';
import PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const RoleDeRecouvrementComponent = ({
  data,
  handlePin,
  onChange,
  panel,
}: PanelComponentProps) => {
  const handleChange = (e, { name, value }) => {
    if (/^\d+$/.test(value)) onChange?.({ [name]: value }, panel);
  };

  return (
    <Panel panel={panel} onPin={handlePin}>
      <Form>
        <Form.Input
          value={data?.role ?? 0}
          onChange={handleChange}
          maxLength={7}
          name="role"
          width={16}
          key="role"
          data-testid="roleDeRecouvrementPanel"
        />
      </Form>
    </Panel>
  );
};

export default RoleDeRecouvrementComponent;
